import { FieldFormatSectionProps } from "./FieldFormatSection";
import { TW_FieldFormatSectionLine, TW_FieldFormatSectionLine_Label, TW_FieldFormatSectionLine_Select, TW_FieldFormatSectionLine_TextInput } from "@utils/twClasses";
import { useTranslation } from "react-i18next";
import { DEFAULT_TEXT_FORMAT } from "@utils/constants";
import { TEXT_FORMATS } from "@utils/types";


export function TextFieldFormatSection({ fieldType, format, onFormatChange }: FieldFormatSectionProps) {

    const { t } = useTranslation();

    const textFormat = (format && format.get("textFormat")) ? format.get("textFormat") : DEFAULT_TEXT_FORMAT;
    return (
        <>
            <div className={TW_FieldFormatSectionLine}>
                <p className={TW_FieldFormatSectionLine_Label}>{t("field.format.text.label")}</p>
            
                <select className={TW_FieldFormatSectionLine_Select} value={textFormat} onChange={onFormatChange("textFormat", false)}>
                    {Array.from(TEXT_FORMATS).map(([key, value]) => {
                        let i18nKey = "text.format.description." + key;
                        return <option key={"text-format-" + key} value={value} className="text-base">{t(i18nKey)}</option>
                    })}
                </select>
            </div>
        </>
    )
}
